const dataOffersEnEn = [
  {
    offer: 'links',
    children: [
      {
        id: 'state-of-services',
        text: 'State of services',
        linkTitle: 'State of services',
      },
      {
        id: 'legal-information',
        text: 'Legal informations',
        linkTitle: 'Legal informations',
      },
      {
        id: 'rc-cc',
        text: 'Terms and conditions',
        linkTitle: 'Terms and conditions',
      },
      {
        id: 'manage-cookies',
        text: 'Manage cookies',
        linkTitle: 'Manage cookies',
      },
    ],
  },
];

export default dataOffersEnEn;
